module.exports = __webpack_public_path__ + "static/media/circlechevrot-left.b34251af.svg";